import { useRef, useState } from "react";
import { Mic, Square, Play, Trash2, Bot, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { loadRecordings, play } from "../lib/audio";

const MAX_MS = 20000;

export const Recorder = ({ item, onChange, testid }) => {
  const [state, setState] = useState("idle");
  const rec = useRef(null);
  const timer = useRef(null);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream);
      const chunks = [];
      mr.ondataavailable = (e) => e.data.size && chunks.push(e.data);
      mr.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        clearTimeout(timer.current);
        setState("saving");
        const blob = new Blob(chunks, { type: mr.mimeType || "audio/webm" });
        const fd = new FormData();
        fd.append("text", item.text);
        fd.append("file", blob, `rec.${(mr.mimeType || "audio/webm").includes("mp4") ? "m4a" : "webm"}`);
        try {
          await api.post("/recordings", fd);
          await loadRecordings();
          toast.success("錄音已儲存");
          onChange();
          play(item.text);
        } catch (e) {
          toast.error(e.response?.data?.detail || "儲存失敗");
        }
        setState("idle");
      };
      rec.current = mr;
      mr.start();
      setState("recording");
      timer.current = setTimeout(() => mr.state === "recording" && mr.stop(), MAX_MS);
    } catch {
      toast.error("無法使用麥克風，請允許瀏覽器使用麥克風");
    }
  };
  const stop = () => rec.current?.state === "recording" && rec.current.stop();
  const remove = async () => {
    try {
      await api.delete(`/recordings/${item.recording_id}`);
      await loadRecordings();
      toast.success("已刪除，恢復系統預設發音");
      onChange();
    } catch {
      toast.error("刪除失敗，請再試一次");
    }
  };

  const btn = "w-11 h-11 rounded-full flex items-center justify-center border-2";
  return (
    <div className="flex items-center gap-2 shrink-0" data-testid={testid}>
      <button title="聽系統發音" data-testid={`${testid}-ai`} onClick={() => play(item.text, item.audio_url, { ai: true })} className={`${btn} border-[var(--line)] bg-white text-stone-500`}><Bot size={18} /></button>
      {state === "recording" ? (
        <button title="停止" data-testid={`${testid}-stop`} onClick={stop} className={`${btn} border-red-400 bg-red-500 text-white animate-pulse`}><Square size={16} fill="currentColor" /></button>
      ) : (
        <button title="錄音" data-testid={`${testid}-record`} disabled={state === "saving"} onClick={start} className={`${btn} border-red-200 bg-red-50 text-red-600`}>{state === "saving" ? <Loader2 size={18} className="animate-spin" /> : <Mic size={18} />}</button>
      )}
      {item.recording_id && (
        <>
          <button title="聽我的錄音" data-testid={`${testid}-play-mine`} onClick={() => play(item.text)} className={`${btn} border-green-300 bg-green-50 text-green-700`}><Play size={18} /></button>
          <button title="刪除錄音，恢復系統發音" data-testid={`${testid}-delete`} onClick={remove} className={`${btn} border-[var(--line)] bg-white text-stone-400`}><Trash2 size={16} /></button>
        </>
      )}
    </div>
  );
};
